module.exports = __webpack_public_path__ + "img/chongdianapp.3294dcc9.png";